export const bookingCarRental = {
  UPGRADE: 'bookingCarRental.Upgrade',
  REMOVE: 'bookingCarRental.Remove',
  EDIT: 'bookingCarRental.Edit',
  CANCEL: 'bookingCarRental.Cancel',
  CONDITIONS: 'bookingCarRental.Conditions',
  SHOW_CARS: 'bookingCarRental.ShowCars'
}
